import { FC, MouseEvent } from 'react'
import {
  Box,
  Card,
  H2,
  makeStyles,
  PageTitle,
  TablePagination,
} from '@perk-ui/core'
import {
  NumberParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params'

import useAdverseEvents from '../../features/query-hooks/useAdverseEvents'
import AdverseEventTable from './components/AdverseEventTable'
import AdverseEventTableProviderSelect from './components/AdverseEventTableProviderSelect'

export interface AdverseEventsProps {}

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
  },
  root: {
    padding: theme.spacing(3, 5, 3, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  container: {
    paddingTop: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
}))

const perPage = 10

const AdverseEvents: FC<AdverseEventsProps> = () => {
  const classes = useStyles()

  const [selectValue, setSelectValue] = useQueryParam(
    'doc',
    withDefault(StringParam, ''),
  )
  const [page, setPage] = useQueryParam('page', withDefault(NumberParam, 0))

  const { data: searchResult } = useAdverseEvents({
    providerId: selectValue,
    // `page` as used by MUI table components is 0-indexed while our backend
    // pagination is 1-indexed.
    // ¯\_(ツ)_/¯
    page: page + 1,
    perPage,
  })
  const count = searchResult?.meta.count || 0
  const tableData = searchResult?.adverseEvents || []

  const handleChangePage = (
    _event: MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage)
  }

  const handleSetSelectValue = (val: string) => {
    setSelectValue(val)
    setPage(0)
  }

  return (
    <Box className={classes.root}>
      <PageTitle title="Adverse Events" />
      <H2 className={classes.title}>Adverse Events</H2>
      <Card className={classes.container}>
        <AdverseEventTableProviderSelect
          setSelectValue={handleSetSelectValue}
          selectValue={selectValue}
        />
        <AdverseEventTable
          data={tableData}
          pagination={
            tableData.length > 0 && (
              <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={count}
                rowsPerPage={perPage}
                page={page}
                onPageChange={handleChangePage}
              />
            )
          }
        />
      </Card>
    </Box>
  )
}

export default AdverseEvents
